const translates: { [key: string]: { id: string } } = {
  noResultsMessage: { id: 'no_results' },
  users: { id: 'users' },
  userGroups: { id: 'user_groups' },
}

export default translates
